import { BooleanInput, Create, SimpleForm, TextInput, type CreateProps } from "react-admin";

export default function FmbThaliDistributorCreate(props: CreateProps) {
  return (
    <Create {...props} title="Create thali distributor">
      <SimpleForm>
        <TextInput source="name" fullWidth isRequired />
        <TextInput
          source="phone"
          fullWidth
          helperText="E.164 phone (e.g. +919876543210). Required when portal access is enabled."
        />
        <BooleanInput
          source="portalEnabled"
          label="Portal access"
          defaultValue={false}
          helperText="Allow this distributor to sign in with phone OTP at /fmb-thali-distributor/login"
        />
        <BooleanInput source="isActive" defaultValue />
        <TextInput source="remarks" fullWidth multiline />
      </SimpleForm>
    </Create>
  );
}
